import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { IPurchaseOrder, IPurchaseOrders, IPurchaseOrderState } from "../interfaces/PurchaseOrder/IPurchaseOrder";
import { IPurchaseOrderDetails } from "../interfaces/PurchaseOrder/IPurchaseOrderDetail";

const initialState: IPurchaseOrderState = {
    purchaseOrders: [],
    purchaseOrder: {
        id: 0,
        vendorId: 0,
        userId: 0,
        type: '',
        orderNumber: '',
        salesOrderNumber: '',
        description: '',
        term: '',
        department: '',
        discounts: '',
        orderDate: new Date(),
        createdAt: new Date(),
        updatedAt: new Date(),
        vendor: null,
        user: null,
        purchaseOrderDetails: null
    }
}

export const purchaseOrderSlice = createSlice({
    name: 'purchaseOrderSlice',
    initialState,
    reducers: {
        setPurchaseOrder: (state, action: PayloadAction<IPurchaseOrder>) => {
            console.log("PAYLOAD", action.payload);
            state.purchaseOrder = action.payload;
        },
        setPurchaseOrderDetails: (state, action: PayloadAction<IPurchaseOrderDetails>) => {
            console.log("PAYLOAD", action.payload);
            if (state.purchaseOrder != null) {
                state.purchaseOrder.purchaseOrderDetails = action.payload;
            }
        },
        setPurchaseOrders: (state, action: PayloadAction<IPurchaseOrders>) => {
            state.purchaseOrders = action.payload;
        },
        setPurchaseOrderState: (state, action: PayloadAction<IPurchaseOrderState>) => {
            state.purchaseOrder = action.payload.purchaseOrder;
            state.purchaseOrders = action.payload.purchaseOrders;
        }
    }
})

export const { setPurchaseOrder, setPurchaseOrders, setPurchaseOrderDetails } = purchaseOrderSlice.actions;

export const selectPurchaseOrder = (state: RootState) => state.purchaseOrder.purchaseOrder;
export const selectPurchaseOrders = (state: RootState) => state.purchaseOrder.purchaseOrders;
export const selectPurchaseOrderState = (state: RootState) => state.purchaseOrder;

export default purchaseOrderSlice.reducer;